export const config = {
	api_url: 'https://gym-reactapp.herokuapp.com'
}